<template>
  <div class="signup-container" style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      padding: 10px;
      height: 100%;
    ">
    <FormHeader title="text.login_title" secondaryTitle="text.login_subtitle" />
    <div class="form" style="
        background-color: #ecf4f6;
        padding: 5%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
        margin: 2%;
      ">
      <input v-model="firstName" type="text" :placeholder="this.$i18n.t('chat.first_name')"
        :style="validationErrors.firstName ? errorStyles : defaultStyles"
        @blur="validateField('firstName', namePattern)" />
      <input v-model="lastName" type="text" :placeholder="this.$i18n.t('chat.last_name')" :style="defaultStyles" />
      <input v-model="email" type="email" :placeholder="this.$i18n.t('chat.log_email')"
        :style="validationErrors.email ? errorStyles : defaultStyles" @blur="validateField('email', emailPattern)" />
      <div class="password-container" style="position: relative">
        <input v-model="password" :type="showPassword ? 'text' : 'password'" placeholder="Mot de passe (*)"
          :style="validationErrors.password ? errorStyles : defaultStyles"
          style="padding-right: 30px; box-sizing: border-box" @blur="validateField('password', passwordPattern)" />
        <button type="button" style="
            position: absolute;
            right: 1.5em;
            top: 50%;
            transform: translateY(-50%);
            background: none;
            border: none;
            cursor: pointer;
          " @click="togglePasswordVisibility">
          <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" height="16" width="20" viewBox="0 0 640 512">
            <path
              d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" height="16" width="18" viewBox="0 0 576 512">
            <path
              d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
          </svg>
        </button>
      </div>
      <p v-if="validationErrors.password" class="password-hint" style="font-size: 0.6em">
        <i>Password must contain at least 8 characters, including at least 1
          number</i>
      </p>
      <ToggleCGV :CGV="CGV_value" :toggle="toggleCGV" /> 
      <button v-if="!loading" :style="buttonStyles" @click="submitForm">
        S'inscrire
      </button>
      <div v-else style="display: flex; justify-content: center; align-items: center">
        <div class="loader-container">
          <div class="loader"></div>
        </div>
      </div>
      <p v-if="submitError" style="
          color: red;
          font-size: 0.6em;
          display: flex;
          justify-content: center;
          align-items: center;
        ">
        <!-- TODO : pull from i18n instead -->
        <i>
          {{ submitError }}
        </i>
      </p>
      <div class="login" style="
          display: flex;
          flex-direction: column;
          text-align: center;
          margin: 0.5em auto;
        ">
        <p style="font-size: small; color: #707070">
          Vous avez déjà un compte ? <br />
          <button style="text-decoration: underline; margin-top: 1em; background: none; border: none; color:#707070"
            @click="redirectTo">
            Se connecter
          </button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { customLogger } from "../../utils";
import FormHeader from "../customs/FormHeader_Formacast.vue";
import ToggleCGV from "../customs/ToggleCGV_Formacast";
export default {
  name: "SignupForm",
  components: {
    FormHeader,
    ToggleCGV
  },
  props: {
    /**
     * @param {string} redirect - name of the redirect to change to
     * @return {void}
     */
    redirect: {
      type: Function,
      required: false,
      default: () => {
        customLogger("Redirect Called");
      },
    },
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      loading: false,
      submitError: null,
      validationErrors: {
        firstName: false,
        email: false,
        password: false,
      },
      showPassword: false,
      namePattern: /^[a-zA-Z\s]{2,}$/,
      emailPattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      passwordPattern: /^(?=.*\d).{8,}$/,
      errorStyles: {
        color: "red",
        border: "1px solid red",
        borderRadius: "1em",
        transition: "0.3s ease-in-out",
        width: "100%"
      },
      defaultStyles: {
        transition: "0.3s ease-in-out",
        color: "#747474",
        border: "1px solid #747474",
        borderRadius: "1em",
        transition: "0.3s ease-in-out",
        backgroundColor: "transparent",
        width: "100%"
      },
      responseError: null,
      CGV_value: false,

    };
  },
  computed: {
    isFormValid() {
      return (
        this.emailPattern.test(this.email) &&
        this.passwordPattern.test(this.password) &&
        this.namePattern.test(this.firstName) &&
        this.CGV_value
      );
    },
    buttonStyles() {
      return {
        transition: "0.3s ease-in-out",
        backgroundColor: this.isFormValid ? "#264c78" : "#d3d3d3",
        padding: "10px 15px",
        color: this.isFormValid ? "white" : "#a9a9a9",
        borderRadius: "25px",
        margin: "0.5em auto",
        border: "none",
        cursor: this.isFormValid ? "pointer" : "default",
      };
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    validateField(fieldName, pattern) {
      if (!pattern.test(this[fieldName])) {
        this.$set(this.validationErrors, fieldName, true);
        setTimeout(
          () => this.$set(this.validationErrors, fieldName, false),
          5000
        );
      } else {
        this.$set(this.validationErrors, fieldName, false);
      }
    },
    async closeModal() {
      this.loading = false;
      this.$store.commit(
        "SET_DATA_SUBSCRIPTION",
        this.modal?.intent
      );
      this.redirectTo("login");
    },
    async submitForm() {
      if (!this.isFormValid) return;
      this.responseError = null;
      this.loading = true;
      this.$store.dispatch("SET_MODAL", {
        type: "loader",
        body: "Veuillez Patienter",
      });
      try {
        await this.$store.dispatch("CREATE_NEW_USER_BY_EMAIL", {
          name: this.name,
          email: this.email,
          password: this.password,
          firstname: this.firstName,
          lastname: this.lastName,
        });
        await this.$store.dispatch("SET_MODAL", {
          type: "success",
          body: "Merci pour votre inscription, vous allez recevoir un email de confirmation pour activer votre compte.",
        }).then(() => {
          this.closeModal();
        });
        this.loading = false
      } catch (e) {
        this.submitError = e.data.error;
        this.modal = {
          type: "error",
          message: e.data.error, // TODO move to i18n,
          show: true
        }
        if (this.submitError == "login.error.users_email_already_exist") {
          this.submitError = this.$i18n.t("chat.email_exists");
          this.$store.dispatch("SET_MODAL", {
            type: "error",
            body: this.submitError,
          });
        }
      } finally {
        this.loading = false;
      }
    },
    toggleCGV() {
      this.CGV_value = !this.CGV_value;
    },
    redirectTo() {
      this.redirect("login");
    },
  },
};
</script>